import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 热门搜索
export const hotSearchApi = (params) =>
  request.get("hotSearch", { lang, params });

// 首页
export const indexApi = (params) => request.get("index", { lang, params });

// 搜索
export const searchApi = (params) => request.get("search", { lang, params });

// 客户来源列表
export const customerSourceApi = (params) =>
  request.get("customerSource", { lang, params });

//导航栏产品列表
export const navProductsApi = (params) =>
  request.get("productTree", { lang, params });

// 产品分类列表
export const categoriesApi = (params) =>
  request.get("categories", { lang, params });

// 产品列表
export const productsApi = (params) =>
  request.get("products", { lang, params });

// 产品销售排行榜
export const productSalesApi = () =>
  request.get("/productSalesStats", { lang });

// 产品详情
export const productDetailApi = (id) => request.get("products/" + id, { lang });

// 产品案例详情
export const caseDetailApi = (params) =>
  request.get("productCase", { lang, params });

// 解决方案分类列表
export const solutionCategoriesApi = (params) =>
  request.get("solutionCategories", { lang, params });

// 解决方案列表
export const solutionsApi = (params) =>
  request.get("solutions", { lang, params });

// 解决方案详情
export const solutionsDetailApi = (id) =>
  request.get("solutions/" + id, { lang });

// 通用分类列表
export const generalCategoriesApi = (params) =>
  request.get("generalCategories", { lang, params });

// 文章分类列表
export const articleCategoriesApi = (params) =>
  request.get("articlesCategories", { lang, params });

// 文章列表
export const articlesApi = (params) =>
  request.get("articles", { lang, params });

// 上一篇/下一篇文章
export const articleNavigationApi = (id) =>
  request.get(`articles/${id}`, { lang });

// 添加反馈
export const feedbackApi = (data) =>
  request.post("feedback", { lang, ...data });

// 反馈类型列表
export const feedbackCategoriesApi = (params) =>
  request.get("feedbackCategory", { lang, params });

// 文档分类列表
export const documentCategoriesApi = (params) =>
  request.get("documentCategories", { lang, params });

// 文档列表
export const documentsApi = (params) =>
  request.get("documents", { lang, params });

// 产品视频/文档资料列表
export const productDocumentsApi = (params) =>
  request.get("product/documents/list", { lang, params });

// 联系我们
export const customerInquiriesApi = (data) =>
  request.post("customerInquiries", { lang, isFormData: true, ...data });

// 获取联系方式
export const contactInfoApi = () => request.get("/contactInfo", { lang });

// 记录联系我们产品点击埋点
export const recordProductClickApi = (data) =>
  request.post("/recordProductClick", { lang, ...data });

// 加入我们
export const jobsApi = (params) => request.get("jobs", { lang, params });

// 注册
export const registerApi = (data) =>
  request.post("register", { lang, isFormData: true, ...data });

// 登录
// 使用表单 POST，避免密码出现在浏览器历史、服务端访问日志及代理日志中。
export const loginApi = (data) =>
  request.post("login", { lang, isFormData: true, ...data });

// 退出登录
export const logoutApi = () => request.post("/logout", { lang });

// 忘记密码
export const forgetPasswordApi = (data) =>
  request.post("/forgetPassword", { lang, isFormData: true, ...data });

// 修改密码
export const changePasswordApi = (data) =>
  request.post("/changePassword", { lang, isFormData: true, ...data });

// 发送短信验证码
export const sendSmsApi = (data) =>
  request.post("/sendSms", { lang, isFormData: true, ...data });

// 发送邮箱验证码
export const sendEmailApi = (data) =>
  request.post("/sendEmail", { lang, isFormData: true, ...data });

// 获取用户信息
export const getUserInfoApi = () => request.get("/userInfo", { lang });

// 文件上传
export const appUpload = (data) =>
  request.post("uploadImg", { lang, isFormData: true, ...data });

// 私有业务附件。调用方只持久化 data.fileRef，previewUrl 只用于本次页面预览。
export const appUploadPrivate = (data) =>
  request.post("uploadPrivateFile", { lang, isFormData: true, ...data });

// 下单产品计算价格
export const calculatePriceApi = (params) =>
  request.get("/calculatePrice", { lang, params });

// 创建订单
export const createOrderApi = (data) =>
  request.post("/order", { lang, ...data });

// 获取服务器时间
export const getServerTimeApi = () => request.get("/serverTime", { lang });

// 获取订阅时长
export const getOrderDurationsApi = (params) =>
  // 获取产品可用订阅时长
  request.get("/orderDurations", { lang, params });

// 获取用户优惠券
export const getUserCouponsApi = (params) =>
  request.get("/recommendedCoupon", { lang, params });

// 提交合作申请
export const partnershipApi = (data) =>
  request.post("/partnership", { lang, ...data });

// 案例库分类
export const casePageCategory = (params) =>
  request.get("/productCasePageCategoryList", { lang, params });

// 产品下所有的案例详情
export const getProductCase = (params) =>
  request.get("/productCase", { lang, params });

// 单个案例详情
export const getCaseDetail = (id) =>
  request.get(`/productCase/${id}`, { lang });

// 根据所有解决方案（按分类分组）
export const getProductCaseByCategory = () =>
  request.get("/allSolutions", { lang });

// 获取字段数据
export const getDictDataList = (params) =>
  request.get("/dictData", { lang, params });
